import { useRef, useState } from 'react';
import { Button, Input, Text } from '@oc-labs/wt-storybook'
import useNavigate from '../../../hooks/useNavigate';
import toast from 'react-hot-toast';
import useAuth from '../../../hooks/useAuth';
import TurnstileCaptcha from '../../../components/TurnstileCaptcha';
import LinkParams from '../../../components/LinkParams';
export default function AuthRegister() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { navigate } = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [captcha, setCaptcha] = useState(null);
  const captchaRef = useRef(null);

  const { register } = useAuth();

  const handleRegister = async () => {
    if (!email) return toast.error(`Email is required.`);
    if (!password) return toast.error(`Password is required.`);
    if (password !== confirmPassword) return toast.error('Passwords do not match.');

    setIsLoading(true);

    try {
      await register({
        email,
        password,
        captcha,
        name: email.split('@')[0],
        callbackURL: window.location.origin + '/auth/email/verify' + window.location.search,
      });
      toast.success('Registration successful! Please check your email to verify your account.', { duration: 6000 });
      navigate('/auth/email/verify');
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Registration failed. Please try again.');
    } finally {
      setCaptcha(null);
      captchaRef.current?.reset();
    }
    
    setIsLoading(false);
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
  };

  return (<div className='p-4 flex flex-col relative'>
    <div className="mb-4">
      <Input label={<Text>Email address</Text>}
        placeholder={"Your email address"}
        onChange={(e) => setEmail(e.target.value)}
        value={email}
        disabled={isLoading}
      />
    </div>

    <div className="mb-4">
      <Input
        label={<Text>Password</Text>}
        placeholder="Your password"
        type='password'
        onChange={handlePasswordChange}
        value={password}
        disabled={isLoading}
      />

      <div className='px-2 leading-none mt-1'>
        <Text
          type="secondary"
          className="text-xs text-gray-400"
        >
          Password must be at least 8 characters long.
        </Text>
      </div>
    </div>

    <div className="mb-8">
      <Input label={<Text>
        Confirm password
        </Text>}
        placeholder="Confirm your password"
        type='password'
        onChange={handleConfirmPasswordChange}
        value={confirmPassword}
        disabled={isLoading}
      />

      <div className="h-3 px-2 mt-1">
        {confirmPassword && password !== confirmPassword && (
          <p className="text-xs text-red-500">
            Passwords do not match.
          </p>
        )}
      </div>
    </div>

    <div className="mb-4 text-center">
      <Button
        type="primary"
        size="large"
        onClick={handleRegister}
        className="w-full mb-4"
        disabled={isLoading}
      >
        Register
      </Button>

      <Text className="text-sm text-gray-500">
        <LinkParams
         to="/auth/login" className="underline">
          Sign In
        </LinkParams>
      </Text>
    </div>

    <TurnstileCaptcha
      ref={captchaRef}
      onSuccess={(token) => setCaptcha(token)} 
      onError={() => console.error('Captcha error')}
    />

    <Text type='secondary' className="text-xs text-center text-gray-400 mx-4">
      Thank you for registering! By creating an account, you agree to our Terms of Service and Privacy Policy.
    </Text>
  </div>)
}
